export { getDateViolations, getNewChangeDateConflict } from './segment-date-change-violations';

export const hasNewCoApplicant = (initialPeople, people) => {
  const initialCoapp = initialPeople?.find((p) => p.isCoApplicant);
  const newCoApp = people?.find((p) => p.isCoApplicant);

  // Prefer id-based comparison — keeps FE in sync with the backend isSameCoApplicant logic.
  // Without this, editing a co-applicant's last name triggers the FCRA disclaimer even though
  // the backend (correctly) recognises the id match and skips the credit pull.
  const samePerson =
    initialCoapp &&
    newCoApp &&
    (initialCoapp.id && newCoApp.id
      ? initialCoapp.id === newCoApp.id
      : initialCoapp.firstName?.trim() === newCoApp.firstName?.trim() &&
        initialCoapp.lastName?.trim() === newCoApp.lastName?.trim() &&
        initialCoapp.dateOfBirth === newCoApp.dateOfBirth);

  const newCoAppAdded = (!initialCoapp && newCoApp) || (newCoApp && !samePerson);

  return newCoAppAdded;
};
